export default {"src":"/_next/static/image/public/images/ic_home_blue.7d583f7ad55b56386495a3c7764cc197.svg","height":14,"width":15};